export const TABLE = {
  CSV: 1,
  BACKEND: 2,
};

export const columnTitles = [
  {
    title: 'TT',
    dataIndex: 'book_id',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Mã đặt xe',
    dataIndex: 'book_code',
  },
  {
    title: 'Thông tin khách hàng',
    dataIndex: 'cstm_name',
  },
  {
    title: 'Ngày tạo',
    dataIndex: 'book_crta',
  },
  {
    title: 'Ngày nhận',
    dataIndex: 'book_rental_date_actual',
  },
  {
    title: 'Ngày trả',
    dataIndex: 'book_return_date_actual',
  },
  {
    title: 'Số ngày thuê',
    dataIndex: 'book_day_num',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Khuyến mãi (<100 là %, >100 là VNĐ)',
    dataIndex: 'promo_val',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Thuê tại thành phố',
    dataIndex: 'city_name',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Nguồn',
    dataIndex: ['book_src_key'],
  },
  {
    title: 'Addons',
    dataIndex: ['bookingAddons', 'name'],
    hideOn: TABLE.CSV,
  },
  {
    title: 'Status',
    dataIndex: ['accept_status'],
    hideOn: TABLE.CSV,
  },
  {
    title: 'Bảo hiểm',
    dataIndex: ['insurance'],
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'CS phụ trách',
    dataIndex: 'support_user_acc_full_name',
  },
  {
    title: 'SSO phụ trách',
    dataIndex: 'supply_side_operator_name',
  },
  {
    title: 'Loại xe',
    dataIndex: 'vhc_type_name',
  },
  {
    title: 'Số chỗ',
    dataIndex: ['vehicle', 'vhc_seat_num'],
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Hộp số',
    dataIndex: ['vehicle', 'vhc_tms_name'],
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Đối tác',
    dataIndex: 'part_name',
  },
  {
    title: 'Đối tác thực tế',
    dataIndex: 'part_name_actual',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Tổng tiền',
    dataIndex: 'book_prie_tota',
  },
  {
    title: 'Tổng tiền thực tế',
    dataIndex: 'book_price_total_actual',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'CX đã thu',
    dataIndex: 'paid_amount',
  },
  {
    title: 'Phí bảo hiểm đã thu',
    dataIndex: 'paid_amount_insurance',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Nguyên nhân fail',
    dataIndex: 'book_resn_name',
  },
  {
    title: 'Payment',
    dataIndex: 'payment_info',
    hideOn: TABLE.CSV,
  },
  {
    title: 'Level',
    dataIndex: 'book_stt_id',
  },
  {
    title: 'Điểm giao xe',
    dataIndex: 'cstm_deli_addr',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Campaign',
    dataIndex: 'utm_campaign',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Content',
    dataIndex: 'utm_content',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Medium',
    dataIndex: 'utm_medium',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'History call',
    dataIndex: 'his_call',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Lịch trình',
    dataIndex: 'book_schl',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Mục đích thuê',
    dataIndex: 'book_rent_pupo',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Điạ phương sinh sống',
    dataIndex: 'cstm_addr_live',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Xe (Dự kiến)',
    dataIndex: 'vhc_part_name',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Xe (thực tế nhận)',
    dataIndex: 'vhc_part_name_actual',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Số điện thoại',
    dataIndex: 'cstm_phon',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Email',
    dataIndex: 'cstm_emai',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Revenue',
    dataIndex: 'revenue',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Commission',
    dataIndex: 'commission',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Is Return Customer',
    dataIndex: 'is_returning_customer',
    hideOn: TABLE.BACKEND,
  },
];
